import ValueObject from 'src/app/core/domain/value_object';

export interface PictureProps {
  url: string;
  path: string;
  disabled?: boolean;
}

export class Picture extends ValueObject<PictureProps> {
  get url(): string {
    return this.props.url;
  }

  get path(): string {
    return this.props.path;
  }

  get disabled(): boolean | undefined {
    return this.props.disabled ?? false;
  }

  private constructor(props: PictureProps) {
    super(props);
  }

  public copyWith(props: PictureProps): Picture {
    return Picture.create({
      ...this.props,
      ...props,
    });
  }

  public static create(props: PictureProps): Picture {
    return new Picture(props);
  }
}
